// PWA-installatie (2026-09-10): vangt `beforeinstallprompt` één keer globaal op, zodat
// componenten die later mounten (sidebar, banner) hem alsnog kunnen gebruiken.
let deferredPrompt = null
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    deferredPrompt = e
    window.dispatchEvent(new Event('ugc-installable'))
  })
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null
    window.dispatchEvent(new Event('ugc-installed'))
  })
}
export const getInstallPrompt = () => deferredPrompt
export const clearInstallPrompt = () => { deferredPrompt = null }
export const isStandalone = () => typeof window !== 'undefined' && ((window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true)
export const isIOS = () => typeof navigator !== 'undefined' && /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream
export const isSafariIOS = () => isIOS() && /safari/i.test(navigator.userAgent) && !/crios|fxios|edgios/i.test(navigator.userAgent)
export async function promptInstall() {
  const ev = deferredPrompt
  if (!ev) return 'unavailable'
  ev.prompt()
  try { const { outcome } = await ev.userChoice; if (outcome === 'accepted') deferredPrompt = null; return outcome } catch { return 'dismissed' }
}
